import { render } from "./EmailIndex.vue?vue&type=template&id=9b9fd584&scoped=true&ts=true"
import script from "./EmailIndex.vue?vue&type=script&lang=ts"
export * from "./EmailIndex.vue?vue&type=script&lang=ts"

import "./EmailIndex.vue?vue&type=style&index=0&id=9b9fd584&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b9fd584"]])

export default __exports__